export default __webpack_public_path__ + "static/media/leftimg.00c9edf8.svg";